import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import WalletOnboardingA from "../WalletOnboardingA";
import WalletOnboardingB from "../WalletOnboardingB";
import BusinessLoader from "../../../common/BusinessLoader";
import {
  analytics,
  getWalletOnboardingVariant,
  triggerLogEvent,
} from "../../../../config/firebase";
import { useWalletContext } from "../../../../context/WalletContext";

const WalletOnboarding = () => {
  const [isNonIdeal, setIsNonIdeal] = useState(null);
  const { EMIVerified } = useWalletContext();
  const navigate = useNavigate();
  const location = useLocation();
  const hasCheckedVariant = useRef(false);

  useEffect(() => {
    if (EMIVerified) {
      if (location.key !== "default") {
        navigate(-1);
      } else {
        navigate("/BusinessOverview", { replace: true });
      }
      return;
    }
    if (!hasCheckedVariant.current) {
      hasCheckedVariant.current = true;
      getWalletOnboardingVariant().then((value) => {
        setIsNonIdeal(value);
        triggerLogEvent(
          analytics,
          value ? "show_wallet_onboarding_B" : "show_wallet_onboarding_A",
        );
      });
    }
  }, [EMIVerified]);

  if (isNonIdeal === null) return <BusinessLoader loadBusiness />;
  return isNonIdeal ? <WalletOnboardingB /> : <WalletOnboardingA />;
};

export default WalletOnboarding;
